// Shared postMessage contract between the embedded app (inside the iframe)
// and the loader script (running on the host page). Kept dependency-free so
// it can be imported by both the React app and the vanilla loader bundle.

export const DDG_MESSAGE_SOURCE = 'ddg-widget'

export type DdgHeightMessage = {
	source: typeof DDG_MESSAGE_SOURCE
	type: 'height'
	value: number
}

export type DdgCloseMessage = {
	source: typeof DDG_MESSAGE_SOURCE
	type: 'close'
}

export type DdgMessage = DdgHeightMessage | DdgCloseMessage

export function isDdgMessage(data: unknown): data is DdgMessage {
	return (
		typeof data === 'object' &&
		data !== null &&
		(data as any).source === DDG_MESSAGE_SOURCE
	)
}
